import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { InputLabelBadgeTypes } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { TextBadge } from '../icons/TextBadge'

export type InputLabelBadgeProps = {
  badgeType: InputLabelBadgeTypes
}

type InputLabelBadgeConfig = {
  VISIBLE_TO_CLIENT: string
}

export const InputLabelBadge: FunctionComponent<InputLabelBadgeProps> = ({ badgeType }) => {
  const { formatMessage } = useIntl()

  const INPUT_LABEL_BADGES: Record<keyof InputLabelBadgeConfig, string> = {
    VISIBLE_TO_CLIENT: formatMessage({
      defaultMessage: 'Visible To Client',
      description: 'Form label text indicating that the inputted value will be seen by the client.',
    }),
  }

  const text = INPUT_LABEL_BADGES[badgeType as keyof InputLabelBadgeConfig]

  return <TextBadge text={text} variant={BadgeVariant.ATTENTION} shape={BadgeShape.RECT} bold />
}
